import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { decrementPilingCounter } from '@bridebook/web/lib/app/actions';
import { getLastPath, getPreviousPath } from '@bridebook/web/lib/app/selectors';
import { goHomeBack } from '@bridebook/web/lib/ui/actions';
import { UrlHelper } from '@bridebook/web/lib/url-helper';
import { useSelector } from '@bridebook/web/lib/utils';

export type PreventableEvent = Pick<Event, 'preventDefault'>;

interface IArgs {
  isBackEnabled?: boolean;
}

export const useNavigateBack = ({ isBackEnabled }: IArgs = {}) => {
  const dispatch = useDispatch();
  const previousPath = useSelector(getPreviousPath);
  const lastPath = useSelector(getLastPath);

  const isPreviousPathValid = useMemo(
    () =>
      previousPath !== '' &&
      !`${previousPath} ${lastPath}`.includes(UrlHelper.onboarding) &&
      !`${previousPath}`.includes(UrlHelper.signup),
    [previousPath, lastPath],
  );

  const navigateBack = useCallback(() => {
    dispatch(goHomeBack({ back: isPreviousPathValid || !!isBackEnabled }));
    dispatch(decrementPilingCounter());
  }, [dispatch, isBackEnabled, isPreviousPathValid]);

  const navigateBackWithPreventDefault = useCallback(
    (e?: PreventableEvent) => {
      e?.preventDefault?.();
      navigateBack();
    },
    [navigateBack],
  );

  return { navigateBack, navigateBackWithPreventDefault };
};
